export default __webpack_public_path__ + "static/proxima-nova-600-i-f4caec6fdb70c29d2bd6e19c480b48d6.woff";